import type { ReactElement } from 'react';
import React from 'react';
import { isMultiSearchEnabled } from 'feature-flags';

const ResetSearchOnUnMount = ({ children, resetSearch }: { children: ReactElement; resetSearch?: () => void }) => {
    React.useEffect(() => {
        return () => {
            if (isMultiSearchEnabled() && resetSearch) {
                resetSearch();
            }
        };
    }, [resetSearch]);
    return children;
};

export default ResetSearchOnUnMount;
